import {
	PLAID_INSTITUTION_REORDER,
	RETRIEVE_PLAID_ACCOUNTS_BEGIN,
	RETRIEVE_PLAID_ACCOUNTS_FAIL,
	RETRIEVE_PLAID_ACCOUNTS_SUCCESS,
	RETRIEVE_PLAID_TRANSACTIONS_BEGIN,
	RETRIEVE_PLAID_TRANSACTIONS_FAIL,
	RETRIEVE_PLAID_TRANSACTIONS_SUCCESS,
	START_SHOW_BANKS,
	TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_SUCCESS,
	TOGGLE_SHOW_BANK_ACCOUNT_TRANSACTIONS,
	TOGGLE_SHOW_CLOSED_ACCOUNTS
} from '../actions/plaid';
import {
	HIDE_BANK_TRANSACTION_BEGIN,
	SUMMARY_PAGE_TAB_CHANGE,
	TOGGLE_SHOW_HIDDEN_BANK_TRANSACTIONS
} from '../actions/dashboard';
import { END_SHOW_BANKS, PLAID_INNER_ACCOUNT_REORDER } from "../actions/plaid.js";
import moment from 'moment';
import LadderLocalStorage from "../../utilities/LadderLocalStorage.jsx";
import { HIDE_BANK_TRANSACTION_SUCCESS } from "../actions/dashboard.js";
import yearMonthToDateKey from "../../utilities/yearMonthToDateKey.js";
import { ACCOUNT_INDEX_SUCCESS, ACCOUNT_SAVE_SUCCESS } from "../actions/accounts.js";

const initialState = {
	plaidAccountsRaw: null,
	plaidTransactionDatesCached: {},
	plaidTransactionDatesUpdating: {},
	showingBankAccountTransactionsWithinTransactions: LadderLocalStorage.getItem('showingBankAccountTransactionsWithinTransactions', false),
	showingHiddenBankTransactions: false,
	/** Closed accounts, and banks with nothing else, are left off the Banks page unless this is on. */
	showClosedAccounts: LadderLocalStorage.getItem('showClosedAccounts', false),

	/** From account/index and every account write: the logos an institution may be given, and whether the user may merge and delete. */
	accountOptions: { logoChoices: [], isBudgetAdmin: false },

	retrievingPlaidAccounts: true,
	showingBanks: true,
	lastHiddenBankTransaction: null,
};

export default (state = initialState, action) => {
	switch(action.type) {
		case TOGGLE_SHOW_HIDDEN_BANK_TRANSACTIONS: {
			return {
				...state,
				showingHiddenBankTransactions: !state.showingHiddenBankTransactions,
			};
		}
		case HIDE_BANK_TRANSACTION_BEGIN: {
			return {
				...state,
				plaidTransactionDatesCached: { ...state.plaidTransactionDatesCached },
				lastHiddenBankTransaction: action.payload
			};
		}
		case HIDE_BANK_TRANSACTION_SUCCESS: {
			return {
				...state,
				lastHiddenBankTransaction: action.payload
			};
		}
		case START_SHOW_BANKS: {
			return {
				...state,
				showingBanks: true,
			};
		}
		case END_SHOW_BANKS: {
			return {
				...state,
				showingBanks: false,
			};

		}
		case PLAID_INSTITUTION_REORDER: {
			const { startIndex, endIndex } = action.payload;
			const plaidAccountsRaw = state.plaidAccountsRaw;
			const list = [...plaidAccountsRaw];
			const [removed] = list.splice(startIndex, 1);
			list.splice(endIndex, 0, removed);
			return {
				...state,
				plaidAccountsRaw: list
			};
		}
		case PLAID_INNER_ACCOUNT_REORDER: {
			const { selectedPlaidInstitutionAccount, startIndex, endIndex } = action.payload;
			const plaidAccountsRaw = state.plaidAccountsRaw;
			const list = [...selectedPlaidInstitutionAccount.accounts];
			const [removed] = list.splice(startIndex, 1);
			list.splice(endIndex, 0, removed);

			const updatedAccountList = [...plaidAccountsRaw];
			const theNewPlaidInstitutionReference = plaidAccountsRaw.find((plaidInstitutionAccount) => {
				return plaidInstitutionAccount.id === selectedPlaidInstitutionAccount.id;
			});
			theNewPlaidInstitutionReference.accounts = list;
			return {
				...state,
				plaidAccountsRaw: updatedAccountList
			};
		}
		case TOGGLE_SHOW_CLOSED_ACCOUNTS: {
			const setTo = !state.showClosedAccounts;
			LadderLocalStorage.setItem('showClosedAccounts', setTo);
			return {
				...state,
				showClosedAccounts: setTo
			};
		}
		case TOGGLE_SHOW_BANK_ACCOUNT_TRANSACTIONS: {
			const setTo = !state.showingBankAccountTransactionsWithinTransactions;
			LadderLocalStorage.setItem('showingBankAccountTransactionsWithinTransactions', setTo);
			return {
				...state,
				showingBankAccountTransactionsWithinTransactions: setTo
			};
		}
		case RETRIEVE_PLAID_TRANSACTIONS_BEGIN: {
			const { year, month } = action.payload;
			const plaidTransactionDatesUpdating = {
				...state.plaidTransactionDatesUpdating,
				[yearMonthToDateKey(year, month)]: true,
			};
			return {
				...state,
				plaidTransactionDatesUpdating
			};
		}
		case RETRIEVE_PLAID_TRANSACTIONS_SUCCESS: {
			const { year, month, transactions, transactionFinder } = action.payload;
			const plaidTransactionDatesUpdating = {
				...state.plaidTransactionDatesUpdating,
			};
			delete plaidTransactionDatesUpdating[yearMonthToDateKey(year, month)];

			transactions.sort((a, b) => {
				return a.date.isAfter(b.date) ? -1 : 1;
			});
			transactionFinder.setBankTransactions(transactions);
			transactionFinder.plaidTransactions.markMonthAsRetrieved(year, month);
			return {
				...state,
				plaidTransactionDatesUpdating
			};
		}
		case RETRIEVE_PLAID_TRANSACTIONS_FAIL: {
			const { year, month } = action.payload;
			const plaidTransactionDatesUpdating = {
				...state.plaidTransactionDatesUpdating,
			};
			delete plaidTransactionDatesUpdating[yearMonthToDateKey(year, month)];
			return {
				...state,
				plaidTransactionDatesUpdating
			};
		}
		case ACCOUNT_INDEX_SUCCESS: {
			return {
				...state,
				plaidAccountsRaw: action.payload,
				accountOptions: action.meta || state.accountOptions,
				retrievingPlaidAccounts: false,
			};
		}
		case ACCOUNT_SAVE_SUCCESS: {
			return {
				...state,
				plaidAccountsRaw: action.payload,
				accountOptions: action.meta || state.accountOptions,
			};
		}
		/** Editing an account or institution answers with the whole list, as these do. */
		case TOGGLE_ADDED_TO_TOTAL_ASSETS_FOR_ACCOUNT_SUCCESS: {
			return {
				...state,
				plaidAccountsRaw: action.payload,
			};
		}
		case RETRIEVE_PLAID_ACCOUNTS_SUCCESS: {
			return {
				...state,
				plaidAccountsRaw: action.payload,
				retrievingPlaidAccounts: false,
			};
		}
		case RETRIEVE_PLAID_ACCOUNTS_BEGIN: {
			return {
				...state,
				retrievingPlaidAccounts: true,
			};
		}
		case RETRIEVE_PLAID_ACCOUNTS_FAIL: {
			return {
				...state,
				retrievingPlaidAccounts: false,
			};
		}
		default:
			return state;
	}
}